import Vue from 'vue'
import axios from 'axios'
axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios

export default {
	install(Vue, options) {
		//接口地址
		// Vue.prototype.api = "https://rsc-test.ssc-hn.com:30999";  // 测试环境
		// Vue.prototype.api = "http://10.100.117.54:9012";  // 测试环境
		// Vue.prototype.api = "http://220.174.232.142:9016";	//
		// Vue.prototype.api = "http://www.rschn.com:9002";	//试运行环境
		// Vue.prototype.api = "http://www.hn-ssc.com";	//正式环境
    Vue.prototype.api = "";	//打包环境

		//通用错误处理
		Vue.prototype.getError = function(data) {
			if(data.code == 1000) {
				store.commit(types.LOGOUT);
			} else {
				// alert(data.msg);
        console.log(data)
			}
		};
		//数据信息收集
		Vue.prototype.getVisitData = function() {
			let that=this;
            that.$axios({
                method:'get',
                url:that.api+'/bootdo/system/tongji/saveVisitdata',
                params:{
                    pageAddress:window.location.href,
                }
            }).then(function(msg){
                //console.log(msg.data);
                if(msg.data.code==100){
                    
                }else{
                    //that.getError(msg.data);
                }
            });
		};
		//获取地址栏语言标识
		Vue.prototype.getUrlLang = function(url) {
			if(url.indexOf("/zh/")>=0){
				return "zh";
		    }else if(url.indexOf("/en/")>=0){
		        return "zh";
		    }else if(url.indexOf("/ru/")>=0){
		        return "zh";
		    }
		};
		
		

	}
}
//过滤器
Vue.filter('formatDate', function(time, dateType) {
	// 返回处理后的值
    if(time){
        time = time.replace(/-/g,"/");
    }
	var date = new Date(time);
	if(dateType == null) {
		return formatDate(date, 'yyyy-MM-dd');
	} else {
		return formatDate(date, dateType);
	}

})



export function formatDate(date, fmt) {//2018-03-21 18:08:48
	if(/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds()
	};
	for(let k in o) {
		if(new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + '';
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
		}
	}
	return fmt;
};

function padLeftZero(str) {
	return('00' + str).substr(str.length);
};



